import React from 'react';
import LinearProgress from '@mui/material/LinearProgress';

export default ({
  title = '', value = 0, height = 20, color = '', onClick = () => {}, className = '',
}) => {
  const style = {
    height,
  };

  if (!color) {
    color = value < 50 ? 'green' : value < 80 ? 'yellow' : 'red';
  }

  return (
    <div className={`progress ${className}`} onClick={onClick}>
      <LinearProgress
        className={`progress-bar ${color}`}
        variant="determinate"
        color="secondary"
        value={value}
        style={style}
      />
      {title && <div className="progress-caption" style={{ height }}>{title}</div>}
    </div>
  );
};
